export default __webpack_public_path__ + "62ac5660a3c0c2ebb9bde97da45a1e00.png";